import { render, staticRenderFns } from "./newsdetail.vue?vue&type=template&id=1d02b97a&scoped=true"
import script from "./newsdetail.vue?vue&type=script&lang=js"
export * from "./newsdetail.vue?vue&type=script&lang=js"
import style0 from "./newsdetail.vue?vue&type=style&index=0&id=1d02b97a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d02b97a",
  null
  
)

export default component.exports